import * as React from "react"
import { Link } from "react-router-dom";
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import Table from 'react-bootstrap/Table';
import { Typography } from "@mui/material";

// navigation bar covers master's head in the image
// do not show image until it is fixed
const heroImage=<div style={{ display: "grid" }}>
<img
  style={{
    gridArea: "1/1",
    // maxHeight: 600,
  }}
  layout="fullWidth"
  aspectRatio={3 / 1}
  alt=""
  quality="40"
  src="/practiceBanner.jpg"
  formats={["auto", "webp", "avif"]}/>
<div
  style={{
    gridArea: "1/1",
    position: "relative",
    placeItems: "center",
    display: "grid",
  }}
>
</div>
</div>

const Training = () => (
  <><NavigationBar/>
  {heroImage}
{/* Main Content */}
  <Layout>
  <Table style={{tableLayout: "fixed"}}><tbody><tr><td/><td colSpan={7}>
      <Typography variant="h3">
      僧伽居士訓練班
      </Typography>
      </td><td/></tr>
<tr><td/><td colSpan={7}>
<Typography variant="body1"><br/>
永化法師致力於<Link to="/practices">禪淨雙修</Link>，並傳承了中國師父溈仰宗的宣化上人和越南師父臨濟宗的滿覺和尚的教學方法。法師從2005年開始弘揚大乘佛法，願將自己所學傳承給下一代以報師恩，很多法師的僧家俗家弟子通過學習法師的九次第定禪修課得到甚深的禪定功夫。<br/><br/>
​<img src={"/training1.jpg"} style={{float: "left", margin: "15px"}} />
廬山寺現在開創了國際訓練班，歡迎世界各地僧伽居士報名參加。道場的信徒們來自十個不同的國家，永化法師以英語和越語授課，現場有中文翻譯。
<br/><br/>


廬山寺的訓練班極其嚴格，意圖幫助學生了斷生死，開悟證果。即使單單得到阿羅漢的境界已經非常不易，開悟證果則更加困難。因此法師也教導學生們淨土法門，若有學生今生不能開悟，來生得以往生西方極樂世界修行開悟證果。我們歡迎有興趣的同修們在報名參加訓練班之前參訪道場，或者參加我們<Link to="/chanqi">為期一至兩個月的夏季或冬季禪七</Link>。<br/><br/>

​<img src={"/training2.jpg"} style={{float: "right", margin: "15px"}} />
訓練班的​學生們會學習如何認識自己的錯誤而不是他人的錯誤。我們隻有得到智慧才能夠幫助他人，而所有廬山寺的學生們最終都會有能力幫助他人。這也是大乘佛法修行的終極目標：幫助十法界眾生脫離生死。<br/><br/>

永化法師每周末正式授課四小時，在合適的機緣下，也會給予個人指導。所有訓練班的僧伽居士都要按照日常功課時間表在道場出坡，並在有需要的時候做更多的工作，道場工作很多的時候，個人修行的時間會相對比較少。<br/><br/>
如果您想和我們一起修行，請<a href="https://www.chanpureland.org/32852319952510520204.html" target="_blank">聯係我們。</a></Typography></td><td/></tr>
<tr><td/><td colSpan={7}>
<br/>
<Typography variant="body1">
<Table bordered hover>
<thead><tr><td>時間</td><td>日常功課</td></tr></thead>
<tbody><tr><td>4:00 – 6:00 AM</td><td>早課</td></tr>
<tr><td>6:00 – 8:00 AM</td><td>自修</td></tr>
<tr><td>6:00 – 6:30 AM</td><td>居士早餐，僧伽早餐可選</td></tr>
<tr><td>8:00 – 10:40 AM</td><td>出坡</td></tr>
<tr><td>10:40 – 12:00 PM</td><td>上供及午齋</td></tr>
<tr><td>12:45 - 02:45 PM</td><td>大悲懺</td></tr>
<tr><td>3:00 – 5:00 PM</td><td>出坡</td></tr>
<tr><td>​5:30 - 6:00 PM</td><td>內部訓練</td></tr>
<tr><td>6:00 – 8:00 PM</td><td>晚課</td></tr>
</tbody></Table>
</Typography>
</td><td/></tr>
</tbody></Table>
  </Layout>
  </>
)

export default Training
